import React from 'react';
import './stepper.scss';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


export const Stepper = () => {
    const navigate = useNavigate();
    const [ isAnonymizationPath, setIsAnonymizationPath ] = React.useState(false);
    const [ isFileUploadedPath, setIsFileUploadPath ] = React.useState(false);
    const [ isDataLayerPath, setIsDataLayerPath ] = React.useState(false);
    const [ isDataQualityPath, setIsDataQualityPath ] = React.useState(false);
    const [ isInsightsPath, setIsInsightsPath ] = React.useState(false);
    const location = useLocation();

    // React.useEffect(() => {
    //     callApi();
    //     const intervalId = setInterval(callApi, 20000);
    //     return () => clearInterval(intervalId);
    // }, []);

    React.useEffect(() => {
        const getColor = () => {
          const pathname = location.pathname || '';
          if(pathname.includes('anonymization')){
            setIsAnonymizationPath(true);
          }
          if(pathname.includes('files') || pathname.includes('uploadData')){
            setIsFileUploadPath(true);
          }
          if(pathname.includes('insights')){
            setIsInsightsPath(true);
          }
          if(pathname.includes('extraction')){
            setIsDataLayerPath(true);
          }
          if(pathname.includes('quality')){
            setIsDataQualityPath(true);
          }
        };
        getColor();
    }, [location.pathname])

    return (
        <div className='stepper'>
            <div onClick={() => {
               navigate('/steps/files')
            }} className={isFileUploadedPath ?  'file-upload' : 'step'}>
                File Upload
            </div>
            <div onClick={() => {
               navigate('/steps/anonymization')
            }} className={isAnonymizationPath ? 'anonymization' : 'step'}>
                Anonymization
            </div>
            <div onClick={() => {
               navigate('/steps/quality')
            }} className={isDataQualityPath ?  'data-quality' : 'step'}>
                Data Quality
            </div>
            <div onClick={() => {
               navigate('/steps/extraction')
            }} className={isDataLayerPath ? 'data-layer' : 'step'}>
                Data Extraction
            </div>
            <div onClick={() => {
               navigate('/steps/insights')
            }} className={isInsightsPath ? 'insights' : 'step'}>
                Insights
            </div>
        </div>
    );
};
